import React, { Suspense, memo } from "react"
import { Search } from "./Search"
import { adjustedModal } from "./SearchProvider.css"
import {
  useAttachGlobalSearchKeyboardShortcut,
  useSearchActions,
} from "./useSearch"

const LazyModal = React.lazy(() =>
  import("@tokenterminal/ui/Modal").then((mod) => ({ default: mod.Modal }))
)

export const SearchProvider = memo(function SearchProvider() {
  const { closeSearch, isOpen, toggleSearch } = useSearchActions()

  useAttachGlobalSearchKeyboardShortcut(toggleSearch)

  return (
    <Suspense fallback={null}>
      <LazyModal
        closeModal={closeSearch}
        className={adjustedModal}
        isOpen={isOpen}
      >
        <Search closeSearch={closeSearch} />
      </LazyModal>
    </Suspense>
  )
})
